/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Integrations_Zotero_Disconnect_SuccessInputs */

const en_settings_integrations_zotero_disconnect_success = /** @type {(inputs: Settings_Integrations_Zotero_Disconnect_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zotero disconnected`)
};

const es_settings_integrations_zotero_disconnect_success = /** @type {(inputs: Settings_Integrations_Zotero_Disconnect_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zotero desconectado`)
};

/**
* | output |
* | --- |
* | "Zotero disconnected" |
*
* @param {Settings_Integrations_Zotero_Disconnect_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_integrations_zotero_disconnect_success = /** @type {((inputs?: Settings_Integrations_Zotero_Disconnect_SuccessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Integrations_Zotero_Disconnect_SuccessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_integrations_zotero_disconnect_success(inputs)
	return en_settings_integrations_zotero_disconnect_success(inputs)
});